/**
 * Table of Content
 *
 * This component generates a table of content based on the headlines (h2) of the article.
 */
document.addEventListener('alpine:init', () => {
    window.Alpine.data('tableOfContent', (config) => ({
        articleUrl: config.articleUrl,
        open: false,
        showTableOfContent: true,
        loading: true,
        tocEvents: {
            ['@open-toc.window']() {
                this.open = true;
                this.$el.parentElement.classList.remove('hidden');
                this.$el.parentElement.classList.add('block');
            },
            ['@click']() {
                if (this.open) {
                    this.open = false;
                    this.$el.parentElement.classList.remove('block');
                    this.$el.parentElement.classList.add('hidden');
                }
            }
        },
        init() {
            requestAnimationFrame(() => {
                this.generateTOC();
            });
        },
        generateTOC() {
            let articleComponents = document.querySelector('#article-components');
            let tableOfContents = document.querySelector('#table-of-content .headlines');
            let headlines = Array.from(articleComponents.querySelectorAll('h2'));
            if (headlines.length > 0) {
                headlines.forEach((headline, index) => {
                    headline.id = headline.textContent.toLowerCase().replace(/[^a-zA-Z0-9äöüÄÖÜ/ ]/g, '').replace(/ /g, '-').replace('--', '-');
                    let linkItem = document.createElement('a');
                    linkItem.textContent = headline.textContent;
                    linkItem.href = config.articleUrl + '#' + headline.id;
                    tableOfContents.appendChild(linkItem);
                    linkItem.addEventListener('click', () => {
                        event.preventDefault();
                        headline.scrollIntoView({ behavior: 'smooth' });
                        if (this.open) {
                            this.open = false;
                        }
                    });
                });
                this.loading = false;

                let getMainNaviHeightDesktop = parseInt(getComputedStyle(document.body).getPropertyValue('--navbar-main-height'));
                let getTopNaviHeightDesktop = parseInt(getComputedStyle(document.body).getPropertyValue('--navbar-top-height'));
                let progressBarHeight = parseInt(getComputedStyle(document.body).getPropertyValue('--progress-bar-height'));
                let advertisingPromotion = document.querySelector('.advertising-promotion');
                let getAdHeight = advertisingPromotion ? advertisingPromotion.clientHeight : 0;
                let activeEntry = null;
                let intersectingEntries = [];

                const observer = new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            intersectingEntries.push(entry);
                        } else {
                            // removing current entry from the list of intersecting entries if not intersecting anymore
                            intersectingEntries = intersectingEntries.filter(e => e.target !== entry.target);
                        }
                    });
                }, {
                    threshold: 1,
                    rootMargin: '-' + (parseInt(getMainNaviHeightDesktop + getTopNaviHeightDesktop + progressBarHeight + getAdHeight)) + 'px 0px 0px 0px',
                });

                // track all headlines
                headlines.forEach((headline) => {
                    observer.observe(headline);
                });

                // function to update the active class
                function updateActiveClass() {
                    if (intersectingEntries.length === 0) {
                        return;
                    }
                    // Sort the intersecting entries by their position in the viewport
                    intersectingEntries.sort((a, b) => {
                        // we have to get the targets with the current position again
                        // because the boundClientRect is not updated during scrolling
                        // only once when the headline is starting to intersect
                        // -> so the comparison is not correct without updating the target first
                        let targetAId = a.target.id;
                        let targetA = document.querySelector('#' + targetAId);
                        let targetBId = b.target.id;
                        let targetB = document.querySelector('#' + targetBId);
                        return targetA.getBoundingClientRect().top - targetB.getBoundingClientRect().top;
                    });
                    // The first entry in the sorted array is the one closest to the top of the viewport
                    let topEntry = intersectingEntries[0];

                    if (activeEntry) {
                        let activeHref = config.articleUrl + '#' + activeEntry.target.getAttribute('id');
                        tableOfContents.querySelector(`a[href="${activeHref}"]`).classList.remove('active');
                    }

                    const id = topEntry.target.getAttribute('id');
                    let href = config.articleUrl + '#' + id;
                    tableOfContents.querySelector(`a[href="${href}"]`).classList.add('active');

                    activeEntry = topEntry;
                }

                // Call the update function on each scroll event
                window.addEventListener('scroll', updateActiveClass);
            } else {
                this.showTableOfContent = false;
            }
        },
    }));
});
